import React, { useState, useEffect } from 'react';
import { Button, FormControl, Paper, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import API from '../../../axios/api';
import * as actions from '../../../store/actions';
import AutoComplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner';

const TenantChangeEquipmentModel = (props) => {
  const dispatch = useDispatch();

  const equipmentModels = useSelector(state => state.tenants.equipmentModels);
  const loadingEquipmentModels = useSelector(state => state.tenants.equipmentModelsLoading);
  const selectedEquipmentRedux = useSelector(state => state.tenants.selectedEquipment);
  const loadingSelectedEquipment = useSelector(state => state.tenants.selectedEquipmentLoading);

  const [equipmentId, setEquipmentId] = useState('');
  const [searchTextEquipmentModels, setSeachTextEquipmentModels] = useState('');
  const [selectedEquipmentModel, setSelectedEquipmentModel] = useState({});
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [lastEquipmentId, setLastEquipmentId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(actions.tenantFetchEquipmentModels(props.tenantId));
  }, []);

  const equipmentModelsFormated = equipmentModels.map((equipmentModel) => ({ value: equipmentModel._id, label: equipmentModel.name }))

  const handleSubmit = () => {
    if (!selectedEquipment || !selectedEquipmentModel) return;
    setLoading(true);
    API.patch(`equipments/changeEquipmentModel/${selectedEquipment._id}/${selectedEquipmentModel.value}`)
      .then((res) => {
        toastr.success('O equipamento foi atualizado com sucesso');
        setSelectedEquipment(null);
        setLoading(false);
        setLastEquipmentId(equipmentId);
        setEquipmentId('');
      })
      .catch((e) => {
        const { message } = e.response.data;
        if (message === 'Same Equipment Model') toastr.error('Não foi possível atualizar o equipamento', 'O tipo do equipamento é o mesmo');
        else toastr.error('Não foi possível atualizar o equipamento');
        setLoading(false);
        setLastEquipmentId('');
      })
  }

  useEffect(() => {
    setSelectedEquipment(selectedEquipmentRedux);
  }, [selectedEquipmentRedux])

  const handleFetchEquipment = () => {
    dispatch(actions.tenantFetchEquipmentById(equipmentId))
  }

  return (
    <Paper style={styles.container}>
      {(loadingSelectedEquipment || loading) && <Spinner overlay />}
      <Typography variant='h6'>Mudar o Tipo de Equipamento</Typography>
      <div style={styles.textInputsContainer}>
        <div style={styles.equipmentContainer}>
          <FormControl variant="standard" style={{width: '45%'}}>
            <TextField
              variant="standard"
              disabled={false}
              label='ID do Equipamento'
              name='equipmentId'
              onChange={event => {
                return setEquipmentId(event.target.value)
              }}
              value={equipmentId}
              margin='normal' />
          </FormControl>
          <Button
              onClick={handleFetchEquipment}
              variant='outlined'
              aria-label="add"
              style={styles.buttonEquipment}
            >
              Procurar Equipamento
          </Button>
        </div>
        {lastEquipmentId !== '' && <p style={styles.successText}>{`O equipamento ${lastEquipmentId} foi atualizado com sucesso.`}</p>}
        <div>
          <div style={styles.equipmentData}>
            <div style={styles.equipmentField}>Tipo Atual do Equipamento: </div>
            <div style={styles.textMargin}>{selectedEquipment?.equipmentModel?.name || '-'}</div>
          </div>
          <div style={styles.equipmentData}>
            <div style={styles.equipmentField}>Número Serial: </div>
            <div style={styles.textMargin}>{selectedEquipment?.serialNumber || '-'}</div>
          </div>
          <div style={styles.equipmentData}>
            <div style={styles.equipmentField}>Referência: </div>
            <div style={styles.textMargin}>{selectedEquipment?.reference || '-'}</div>
          </div>
          <div style={styles.equipmentData}>
            <div style={styles.equipmentField}>Descrição: </div>
            <div style={styles.textMargin}>{selectedEquipment?.description || '-'}</div>
          </div>
        </div>
        <FormControl variant="standard" fullWidth margin='normal'>
          <AutoComplete
            loading={loadingEquipmentModels} // sent to isLoading
            label={'Novo Tipo de Equipamento'}
            data={equipmentModelsFormated} // sent to options
            onSelectValue={(selected) => setSelectedEquipmentModel(selected)} // sent to onChange
            valueSelected={selectedEquipmentModel} // sent to value
            newSearchText={(text) => setSeachTextEquipmentModels(text)}
            name='equipmentModelTenant'
            hasError={false}
          />
        </FormControl>
        <div style={styles.buttonContainer}>
          <Button
            onClick={handleSubmit}
            variant='outlined'
            aria-label="add"
            style={styles.button}
            disabled={!(selectedEquipment?._id && selectedEquipmentModel?.value)}
          >
            Mudar Equipamento
          </Button>
        </div>
      </div>
    </Paper>
  );
};

const styles = {
  container: {
    padding: 20,
    position: 'relative',
  },
  textInputsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    width: '50%'
  },
  buttonEquipment: {
    height: 35,
    width: '50%',
    alignSelf: 'flex-end',
  },
  buttonContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    width : '100%',
  },
  equipmentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 0,
  },
  equipmentData: {
    display: 'flex',
    alignItems: 'center',
  },
  equipmentField: {
    color: "#999",
    fontSize: '0.8rem'
  },
  textMargin: {
    marginLeft: 5
  },
  successText: {
    color: 'green',
    marginTop: 0,
    fontSize: 12
  },
}

export default TenantChangeEquipmentModel;